import React, { useEffect, useState } from 'react';

const ChatMessageNotificationText = ({message}) => {
	const [showEmpty, setShowEmpty] = useState(false);

	useEffect(() => {
		setShowEmpty(true);
	}, [message]);

	useEffect(() => {
		if (showEmpty) {
			setShowEmpty(false);
		}
	}, [showEmpty]);

	return showEmpty ? null : (
		<span className="typing-container">{message}</span>
	);
};

export default ChatMessageNotificationText;